<template>
  <div>
    <v-container fluid>
      <v-card class="v-card--material pt-2 ma-1 rounded-lg" elevation="2">
        <v-card-title class="headline text-decoration-underline">
          Curriculum CMS List view
        </v-card-title>
        <v-card-text class="pa-0">
          <v-row class="pa-4">
            <v-col cols="12" md="12" lg="12" sm="12" xs="12">
              <v-expansion-panels flat focusable v-model="defaultPanel" style="border: solid 1px #e4e4e4">
                <v-expansion-panel>
                  <v-expansion-panel-header class="py-0" @click="handleExpension" disable-icon-rotate
                    style="min-height: 50px" :color="isOpen ? '#5d58ef' : ''" :class="isOpen ? 'white--text' : ''">
                    <span><v-icon :color="isOpen ? 'white' : ''">mdi-filter</v-icon>
                      Filters</span>
                    <template v-slot:actions>
                      <v-icon :color="isOpen ? 'white' : ''">{{
                        isOpen ? 'mdi-minus' : 'mdi-plus'
                      }}</v-icon>
                    </template>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row class="mt-6">
                      <v-col class="px-1" cols="12" md="2" lg="2" sm="4" xs="12">
                        <label class="font-weight-medium body-2">
                          Academic year <span class="error--text">*</span>
                        </label>
                        <v-autocomplete class="my-0 py-1" v-model="academicYearID" :items="academicYearData" key="id"
                          item-value="id" item-text="academicYear" />
                      </v-col>
                      <v-col class="px-1" cols="12" md="2" lg="2" sm="4" xs="12">
                        <label class="font-weight-medium body-2">
                          Business
                        </label>
                        <v-autocomplete class="my-0 py-1" placeholder="Filter by Business" name="businessSelect"
                          v-model="selectedBusinessID" item-value="id" @change="getProgramList()" :items="business"
                          key="id" item-text="name">
                        </v-autocomplete>
                      </v-col>
                      <v-col class="px-1" cols="12" md="2" lg="2" sm="4" xs="12">
                        <label class="font-weight-medium body-2">
                          Programs
                        </label>
                        <v-autocomplete class="my-0 py-1" key="id" placeholder="Filter by Programs" :items="programList"
                          v-model="selectedProgramID" item-text="name" item-value="classID" />
                      </v-col>
                      <v-col class="px-1" cols="12" md="2" lg="2" sm="4" xs="12">
                        <label class="font-weight-medium body-2"> Zone </label>
                        <v-autocomplete class="my-0 py-1" key="id" placeholder="Filter by Zone" :items="zones"
                          v-model="zoneFilter" @change="getZoneFranchisees()" item-text="name" item-value="id" />
                      </v-col>
                      <v-col class="px-1" cols="12" md="2" lg="2" sm="4" xs="12">
                        <label class="font-weight-medium body-2">
                          Center
                        </label>
                        <v-autocomplete class="my-0 py-1" key="id" placeholder="Filter by Center" :items="franchisees"
                          v-model="centerFilter" item-text="companyName" item-value="id" />
                      </v-col>
                      <v-col class="px-1" cols="12" md="2" lg="2" sm="4" xs="12">
                        <label class="font-weight-medium body-2"> Week </label>
                        <v-autocomplete class="my-0 py-1" key="id" placeholder="Filter by Week" :items="weekList"
                          v-model="selectedWeekID" item-text="weekName" item-value="id" />
                      </v-col>
                      <v-col v-if="!$vuetify.breakpoint.xs" cols="12" md="12" lg="12" sm="12" xs="12">
                        <v-card-actions class="justify-center">
                          <v-btn @click="getCurriculumList" color="#5d58ef" class="white--text" small>
                            <v-icon left>mdi-filter</v-icon>Apply Filter
                          </v-btn>
                          <v-btn depressed @click="resetFilter" small>
                            <v-icon left> mdi-restart</v-icon> Reset Filter
                          </v-btn>
                        </v-card-actions>
                      </v-col>
                      <v-col v-else cols="12" xs="12" class="px-0">
                        <v-row no-gutters>
                          <v-col class="mb-2" cols="12" xs="12">
                            <v-btn @click="getCurriculumList" color="#5d58ef" class="white--text" dense
                              style="min-width: 100%">
                              <v-icon left>mdi-filter</v-icon>Apply Filter
                            </v-btn>
                          </v-col>
                          <v-col cols="12" xs="12">
                            <v-btn depressed @click="resetFilter" dense style="min-width: 100%">
                              <v-icon left> mdi-restart</v-icon> Reset Filter
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-col>
            <v-col cols="12" md="12">
              <v-data-table item-key="name" :headers="headers" :items="curriculumnList" disable-pagination
                hide-default-footer>
                <template v-slot:item.week="{ item }">
                  <v-menu max-height="300" :close-on-content-click="false" offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on" outlined color="indigo" title="Click here to view week glance"
                        :disabled="item.week.length <= 0">
                        Week at glance
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-group v-for="(weekGlance, index) in item.week" :key="index + '_' + weekGlance.weekAtGlance">
                        <template v-slot:activator>
                          <v-list-item-content>
                            <v-list-item-title>{{
                              weekGlance.weekAtGlance
                            }}</v-list-item-title>
                          </v-list-item-content>
                        </template>

                        <v-list-item v-for="(week, weekIndex) in weekGlance.week"
                          :key="weekIndex + '_' + week + '_' + index" class="pl-4" link
                          @click="goToCurriculumCms(item, week)">
                          <v-list-item-content>
                            <v-list-item-title>{{ week }}</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list-group>
                    </v-list>
                  </v-menu>
                </template>
                <template v-slot:item.actions="{ item }">
                  <span v-if="isWrite" class="d-flex justify-center">
                    <v-btn @click="toggleModal(item)" class="px-2 ml-1 ma-1" color="primary" depressed small>
                      Edit
                    </v-btn>
                  </span>
                </template>
              </v-data-table>
              <v-row class="mt-2">
                <v-col cols="12" md="4" lg="4" sm="4" xs="12">
                  <v-select v-model="pageSize" :items="pageSizes" label="Items per Page"
                    @change="handlePageSizeChange"></v-select>
                </v-col>
                <v-col cols="12" md="8" lg="8" sm="9" xs="12">
                  <v-pagination class="pb-1" v-model="page" :length="totalPages" :total-visible="10"
                    @input="handlePageChange" />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-dialog persistent v-model="enableModel" max-width="650">
        <form @submit.prevent="saveCMSData">
          <v-card>
            <v-toolbar dense dark color="#5d58ef" elevation="0">
              <v-toolbar-title> Edit Curriculum</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn icon dark @click="closeEditModel">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar-items>
            </v-toolbar>
            <v-card-text>
              <v-row>
                <v-col cols="12" md="12">
                  <label class="font-weight-medium body-2">Select academic year
                    <span class="error--text">*</span></label>
                  <v-autocomplete class="my-0 py-1" placeholder="--Select Academic Year--" v-model="selectedAcademicId"
                    :items="academicYearData" key="id" item-value="id" item-text="academicYear" multiple
                    :error="academicYearFlag" :error-messages="academicYearErrMsg">
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" md="12">
                  <label class="font-weight-medium body-2">
                    Select Class<span class="error--text">*</span></label>
                  <v-autocomplete class="my-0 py-1" placeholder="--Select Class--" name="classSelect"
                    v-model="selectedClassID" item-value="classID" multiple :items="programList" key="classID"
                    item-text="name" :error="classSelectedFlag" :error-messages="classErrorMsg">
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" md="12" v-if="!isZoneCurriculum">
                  <label class="font-weight-medium body-2">Select Zone</label>
                  <v-autocomplete class="my-0 py-1" key="id" placeholder="Select Zone" :items="zoneList"
                    v-model="selectedZoneFilter" multiple item-text="name" item-value="name" clearable
                    @change="getZoneFranchisees()">
                    <template v-if="zoneList.length > 0" v-slot:prepend-item>
                      <div class="pl-4 mb-2">
                        <v-checkbox v-model="selectAllZoneFlag" class="py-0" @change="selectAllZone" hide-details>
                          <template v-slot:label>
                            <span class="ml-3 pl-3">Select All</span>
                          </template>
                        </v-checkbox>
                      </div>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" md="12" v-if="!isZoneCurriculum">
                  <label class="font-weight-medium body-2">Select Centers</label>
                  <v-autocomplete key="id" placeholder="--All Centers--" :items="franchisees"
                    v-model="selectedFranchisees" multiple item-text="companyName" item-value="id" :hide-details="true"
                    clearable>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" md="12" v-if="isZoneCurriculum">
                  <label class="font-weight-medium body-2">Select Zones</label>
                  <v-autocomplete class="my-0 py-1" key="id" placeholder="Select Zone" :items="zones"
                    v-model="selectedZones" multiple item-text="name" item-value="id" clearable :error="zoneSelectedFlag"
                    :error-messages="zoneErrorMsg">
                  </v-autocomplete>
                </v-col>
                <v-col cols="12">
                  <v-card-actions class="justify-end">
                    <v-btn class="white--text" color="#5d58ef" type="submit">Save</v-btn>
                  </v-card-actions>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </form>
      </v-dialog>
    </v-container>
    <loading-icon :value="isLoading" />
  </div>
</template>
<script>
import constants from '@/utils/constants'
import Utils from '@/utils'
import _ from 'lodash'
import { mapGetters } from 'vuex'
import stores from '@/stores'

export default {
  name: 'curriculumCMSListView',
  data () {
    return {
      isOpen: true,
      dialog: false,
      academicYearData: [],
      franchisees: [],
      selectedFranchisees: [],
      selectedClassID: [],
      selectedAcademicId: [],
      zoneFilter: '',
      centerFilter: '',
      isLoading: true,
      franchiseeID: '',
      selectedProgramID: '',
      selectedWeekID: '',
      programList: [],
      weekList: [],
      academicYearID: '',
      enableModel: false,
      business: [],
      selectedBusinessID: '',
      isWrite: false,
      businessProgramMapID: null,
      curriculumnList: [],
      item: [],
      headers: [
        {
          text: 'Academic Year',
          name: 'academicYear',
          value: 'academicYear',
          align: 'center',
          sortable: false
        },
        {
          text: 'Centers/Zone',
          name: 'Centers',
          value: 'center',
          align: 'center',
          maxWidth: '10%',
          sortable: true
        },
        {
          text: 'Weeks',
          name: 'Weeks',
          value: 'week',
          align: 'center',
          maxWidth: '20%',
          sortable: true
        },
        {
          text: 'Program',
          name: 'Program',
          value: 'program',
          align: 'center',
          sortable: true
        }
      ],
      selectedCurriculumCMSId: '',
      academicYearFlag: false,
      academicYearErrMsg: '',
      classSelectedFlag: false,
      classErrorMsg: '',
      zones: [],
      selectedZones: [],
      zoneSelectedFlag: false,
      zoneErrorMsg: '',
      isZoneCurriculum: false,
      defaultPanel: 0,
      page: 1,
      totalPages: 0,
      pageSize: 10,
      pageSizes: [5, 10, 20, 40],
      demoItems: [
        {
          weekAtGlance: 'Week 1-8',
          week: ['Week 1', 'Week 2', 'Week 3', 'Week 4']
        },
        {
          weekAtGlance: 'Week 9-16',
          week: ['Week 9', 'Week 10', 'Week 11', 'Week 12']
        },
        {
          weekAtGlance: 'Week 17-24',
          week: ['Week 18', 'Week 20', 'Week 22']
        }
      ],
      weekGlanceArray: [
        [1, 8],
        [9, 16],
        [17, 24],
        [25, 32],
        [33, 40],
        [41, 48],
        [49, 52]
      ],
      totalWeek: 52,
      weekRange: 8,
      zoneList: [],
      selectedZoneFilter: [],
      selectedObjectForEdit: null,
      selectAllZoneFlag: false,
      CurriculumAdmin: false
    }
  },
  async created () {
    this.create = this.checkModuleAccess('create')
    this.isWrite = Utils.helper.getIsWriteFun(this.$route)
    await this.getAcademicYearsList()
    await this.getFranchiseeList()
    await this.getBusinessList()
    await this.getZoneDetails()
    await this.getWeekList()
    await this.getCurriculumList()
    await this.getZoneFranchisees()

    if (stores.user.me.superAdmin === false) {
      for (const item of stores.user.roles) {
        if (item.role === 'CurriculumAdmin') {
          this.CurriculumAdmin = true
        }
      }
    }
    if (this.CurriculumAdmin || stores.user.me.superAdmin) {
      this.headers.push({
        text: 'Action',
        name: 'Action',
        value: 'actions',
        align: 'center',
        sortable: false
      })
    }
  },
  watch: {
    franchisee: async function (val) {
      await this.onFranchiseeChange()
    },
    academicYear: async function (val) {
      await this.onFranchiseeChange()
    },
    selectedAcademicId: function (newVal) {
      this.academicYearFlag = this.selectedAcademicId.length <= 0
      this.academicYearErrMsg = this.academicYearFlag
        ? 'Please select Academic Year.'
        : ''
    },
    selectedClassID: function (newVal) {
      this.classSelectedFlag = this.selectedClassID.length <= 0
      this.classErrorMsg = this.classSelectedFlag ? 'Please select Class.' : ''
    },
    selectedZones: function (newVal) {
      this.zoneSelectedFlag = this.selectedZones.length <= 0
      this.zoneErrorMsg = this.zoneSelectedFlag ? 'Please select zone.' : ''
    }
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  methods: {
    selectAllZone: function () {
      if (this.selectAllZoneFlag) {
        this.selectedZoneFilter = []
        this.zoneList.forEach(item => {
          this.selectedZoneFilter.push(item.name)
        })
        this.getZoneFranchisees()
        return true
      } else {
        this.selectedZoneFilter = []
      }
    },
    handleExpension: function () {
      this.isOpen = !this.isOpen
    },
    checkModuleAccess: function (moduleName) {
      return Utils.helper.checkAccessByModule(this.$route, moduleName)
    },
    getAcademicYearsList: async function () {
      this.isLoading = true
      let rows = await http.get(
        `${constants.API_URL}/api/franchiseeAcademicYears`
      )
      this.academicYearData = rows.data.rows
      const currentAcademicYear = Utils.getCurrentAcademicYear()
      let academicYear = this.academicYearData.find((y) => {
        return y.academicYear.trim() === currentAcademicYear.trim()
      })
      this.academicYearID = academicYear ? academicYear.id : ''
      this.isLoading = false
    },
    getZoneDetails: async function () {
      try {
        this.isLoading = true
        let result = await http.get(
          `${constants.API_URL}/api/curriculum_cms/get-zones`
        )

        this.zones = result.data
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    fetchZoneDetails: async function () {
      try {
        this.isLoading = true
        let result = await http.get(
          `${constants.API_URL}/api/curriculum_cms/get-zones`
        )

        this.zoneList = result.data
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    getZoneFranchisees: async function () {
      try {
        this.isLoading = true
        let filterSelectedZone = []
        let response = null
        if (this.selectedZoneFilter.length === this.zoneList.length) {
          this.selectAllZoneFlag = true
        } else {
          this.selectAllZoneFlag = false
        }
        if (this.selectedZoneFilter) {
          let zone = this.selectedZoneFilter.map((zone) => {
            return zone
          })
          response = await http.post(
            `${constants.API_URL}/api/franchisee/get/zone-wise-franchisee`,
            {
              zone: zone
            }
          )
          let data = response.data
          this.franchisees = _.map(data, (e) => {
            if (e.id) {
              if (e.id.toString().length === 1) {
                e.companyName = `${'(00' + e.id + ')'} ` + e.companyName
              } else if (e.id.toString().length === 2) {
                e.companyName = `${'(0' + e.id + ')'} ` + e.companyName
              } else {
                e.companyName = `${'(' + e.id + ')'} ` + e.companyName
              }
              e.companyName = e.region
                ? e.companyName + `${' (' + e.region + ')'}`
                : e.companyName
            }
            return e
          })
        }
        if (this.zoneFilter) {
          _.filter(this.zones, (item) => {
            if (this.zoneFilter === item.id) {
              filterSelectedZone.push(item.name)
            }
          })
          response = await http.post(
            `${constants.API_URL}/api/franchisee/get/zone-wise-franchisee`,
            {
              zone: filterSelectedZone
            }
          )
          let data = response.data
          this.franchisees = _.map(data, (e) => {
            if (e.id) {
              if (e.id.toString().length === 1) {
                e.companyName = `${'(00' + e.id + ')'} ` + e.companyName
              } else if (e.id.toString().length === 2) {
                e.companyName = `${'(0' + e.id + ')'} ` + e.companyName
              } else {
                e.companyName = `${'(' + e.id + ')'} ` + e.companyName
              }
              e.companyName = e.region
                ? e.companyName + `${' (' + e.region + ')'}`
                : e.companyName
            }
            return e
          })
        }
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    getFranchiseeList: async function () {
      try {
        this.isLoading = true
        let res = await http.get(`${constants.API_URL}/api/franchisee/active`)
        let data = res.data
        let Data = data.rows
        this.franchisees = _.map(Data, (e) => {
          if (e.id) {
            if (e.id.toString().length === 1) {
              e.companyName = `${'(00' + e.id + ')'} ` + e.companyName
            } else if (e.id.toString().length === 2) {
              e.companyName = `${'(0' + e.id + ')'} ` + e.companyName
            } else {
              e.companyName = `${'(' + e.id + ')'} ` + e.companyName
            }
            e.companyName = e.region
              ? e.companyName + `${' (' + e.region + ')'}`
              : e.companyName
          }
          return e
        })
        if (this.franchisees.length === 1) {
          this.selectedFranchisees = this.franchisees
        }
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    onFranchiseeChange: async function () {
      if (!this.inProgress) {
        this.inProgress = true
        if (this.franchisee) {
          this.franchiseeID = this.franchisee.id
        } else {
          this.franchiseeID = ''
        }
        if (this.academicYear) {
          this.academicYearID = this.academicYear.id
        } else {
          this.academicYearID = ''
        }
        if (this.franchiseeID && this.academicYearID) {
          await this.getFranchiseeList()
        }
        this.inProgress = false
      }
    },
    getWeekList: async function () {
      try {
        this.isLoading = true
        const { data } = await http.get(
          `${constants.API_URL}/api/curriculum_cms/week/get/all`
        )
        if (data) {
          this.weekList = data
        }
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
        console.log('errorMessage', errorMessage)
      }
    },
    getProgramList: async function () {
      try {
        this.isLoading = true
        if (!this.academicYearID) {
          return
        }
        const { data } = await http.get(
          `${constants.API_URL}/api/curriculum_cms/get-program?id=${this.selectedBusinessID}&academicYearID=${this.academicYearID}`
        )
        if (data) {
          this.programList = data.map((obj) => {
            return {
              businessProgramMapID: obj.id,
              classID: obj.classID,
              name: obj.studentClass.name
            }
          })
        }
        if (_.isEmpty(data)) {
          this.errMsg('No Programs Mapped for selected Business!')
          this.selectedBusinessID = ''
          this.resetFilter()
        }
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
        console.log('errorMessage', errorMessage)
      }
    },
    getBusinessList: async function () {
      try {
        this.isLoading = true
        const { data } = await http.get(
          `${constants.API_URL}/api/curriculum_cms/get-business`
        )
        if (data) {
          this.business = data
        }
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
        console.log('errorMessage', errorMessage)
      }
    },
    getCurriculumList: async function () {
      try {
        this.isLoading = true
        if (!this.academicYearID) {
          this.errMsg('Please select Academic Year!')
          return
        }
        let query = ''
        query = `academicYearID=${this.academicYearID}`
        if (this.selectedBusinessID) {
          if (this.programList) {
            if (this.selectedProgramID.length <= 0) {
              this.errMsg('Select Program First!')
            }
          }
        }
        if (this.selectedProgramID) {
          query += `&classID=${this.selectedProgramID}`
        }
        if (this.zoneFilter) {
          query += `&zoneID=${this.zoneFilter}`
        }
        if (this.centerFilter) {
          query += `&franchiseeID=${this.centerFilter}`
        }
        if (this.selectedWeekID) {
          query += `&weekID=${this.selectedWeekID}`
        }
        query += `&page=${this.page - 1}&size=${this.pageSize}`
        const res = await http.get(
          `${constants.API_URL}/api/curriculum_cms/get/all-data?${query}`
        )
        if (res.status === 200) {
          this.curriculumnList = []
          this.totalPages = res.data.totalPages
          res.data.rows.forEach((obj) => {
            let dataObj = {}
            let academicYear = []
            let companyName = []
            let ClassName = []
            dataObj.id = obj.id
            dataObj.list = obj

            // Academic Year Data
            obj.curriculumCMSAcademicYearMaps.forEach((academic) => {
              academicYear.push(academic.franchiseeAcademicYear.academicYear)
            })
            dataObj.academicYear = academicYear.join()

            // Class Data
            if (obj.allCenterAccess) {
              dataObj.center = ['All']
              dataObj.isZoneCurriculum = false
            } else {
              obj.curriculumCMSCenterMaps.forEach((item) => {
                if (item.franchisee) {
                  companyName.push(item.franchisee.companyName)
                }
              })
              if (companyName.length > 0) {
                dataObj.center = companyName.join()
              } else {
                dataObj.center = '-'
              }
              dataObj.isZoneCurriculum = false
            }

            // Zone Data
            if (obj.curriculumCMSZoneMaps.length > 0) {
              obj.curriculumCMSZoneMaps.forEach((item) => {
                if (item.zone !== null && item.zone !== '') {
                  companyName.push(item.zone.name)
                }
              })
              dataObj.center = companyName.join()
              dataObj.isZoneCurriculum = true
            } else {
              if (dataObj.center.length === 0) {
                dataObj.center = '-'
              }
              dataObj.isZoneCurriculum = false
            }

            // Program Data
            obj.curriculumCMSClassMaps.forEach((item) => {
              if (item.studentClass) {
                ClassName.push(item.studentClass.name)
              }
            })
            dataObj.program = ClassName.join()

            // Week Data
            obj.curriculumCMSWeekMaps = _.orderBy(
              obj.curriculumCMSWeekMaps,
              'week.position',
              'asc'
            )
            // dataObj.week = obj.curriculumCMSWeekMaps.map(
            //   (innerObj) => innerObj.week.weekName
            // )
            let weekGlanceObj = {}
            this.weekGlanceArray.forEach((weekRange) => {
              let weekRangeLable = weekRange.join('-')
              weekGlanceObj['Week ' + weekRangeLable] = []
              obj.curriculumCMSWeekMaps.forEach((weekItem) => {
                if (
                  weekItem.week.position >= weekRange[0] &&
                  weekItem.week.position <= weekRange[1]
                ) {
                  weekGlanceObj['Week ' + weekRangeLable].push(
                    weekItem.week.weekName
                  )
                }
              })
            })
            let weekArray = []
            for (const [key, value] of Object.entries(weekGlanceObj)) {
              if (value.length > 0) {
                weekArray.push({
                  weekAtGlance: key,
                  week: value
                })
              }
            }
            dataObj.week = weekArray
            this.curriculumnList.push(dataObj)
          })
          // Modified Curriculum List
          // console.log(this.curriculumnList)
          // let modiFiedCurriculumList = []
          // this.curriculumnList.forEach(item => {
          //   item.week.forEach(week => {
          //     let copyItem = _.cloneDeep(item)
          //     copyItem.week = week
          //     modiFiedCurriculumList.push(copyItem)
          //   })
          // })
          // this.curriculumnList = modiFiedCurriculumList
        } else {
          this.errMsg(res.data.message)
          return
        }
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        return this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    handlePageChange (value) {
      this.page = value
      this.$router.push({
        name: 'curriculumCMSListView',
        params: { current: this.page }
      })
      this.getCurriculumList()
      this.isLoading = true
    },
    handlePageSizeChange (size) {
      this.pageSize = size
      this.page = 1
      this.getCurriculumList()
    },
    resetFilter: function () {
      this.selectedBusinessID = ''
      this.selectedProgramID = ''
      this.programList = []
      this.zoneFilter = ''
      this.centerFilter = ''
      this.selectedWeekID = ''
      this.page = 1
      this.getAcademicYearsList()
      this.getFranchiseeList()
      this.getBusinessList()
      this.getZoneDetails()
      this.getWeekList()
      this.getCurriculumList()
      this.getZoneFranchisees()
    },
    goToCurriculumCms: function (item, week) {
      let curriculumCmsId = ''
      let weekId = ''
      console.log(item)
      item.list.curriculumCMSWeekMaps.forEach((Obj) => {
        curriculumCmsId = Obj.curriculumCMSID
        if (Obj.week.weekName === week) {
          weekId = Obj.week.id
        }
      })
      const routeData = this.$router.resolve({
        name: 'newCurriculumCMS',
        params: { curriculumCmsId: curriculumCmsId, weekId: weekId }
      })
      window.open(routeData.href, '_blank')
    },
    toggleModal: function (item) {
      this.fetchZoneDetails()
      this.selectedZoneFilter = []
      this.selectAllZoneFlag = []
      this.selectedObjectForEdit = item
      this.selectedAcademicId = []
      this.selectedClassID = []
      this.selectedFranchisees = []
      this.selectedCurriculumCMSId = ''
      this.enableModel = !this.enableModel
      this.selectedCurriculumCMSId = item.list.id
      this.selectedZones = []
      this.isZoneCurriculum = item.isZoneCurriculum
      if (item.list) {
        if (item.list.curriculumBusinessProgramMap.businessID) {
          this.selectedBusinessID =
            item.list.curriculumBusinessProgramMap.businessID
          this.getProgramList()
        }
        item.list.curriculumCMSAcademicYearMaps.forEach((item) => {
          this.selectedAcademicId.push(item.franchiseeAcademicYear.id)
        })
        item.list.curriculumCMSClassMaps.forEach((item) => {
          this.selectedClassID.push(item.studentClass.id)
        })
        item.list.curriculumCMSCenterMaps.forEach((item) => {
          if (item.franchisee) {
            this.selectedFranchisees.push(item.franchisee.id)
          }
        })
        item.list.curriculumCMSZoneMaps.forEach((item) => {
          if (item.zone) {
            this.selectedZones.push(item.zone.id)
          }
        })
        // if (this.selectedZoneFilter.length) {
        //   this.getZoneFranchisees()
        // }
        let selectedFranchiseeRegion = []
        _.map(this.selectedFranchisees, selectedFranchisee => {
          let region = _.find(this.franchisees, franchisee => {
            return selectedFranchisee === franchisee.id
          })
          if (region) {
            selectedFranchiseeRegion.push(region.region)
            this.selectedZoneFilter = _.uniqBy(selectedFranchiseeRegion)
          }
          // return selectedFranchiseeRegion
        })
        if (this.selectedZoneFilter.length) {
          this.getZoneFranchisees()
        }
        // this.selectedZoneFilter = selectedFranchiseeRegion
      }
    },
    closeEditModel: function () {
      this.enableModel = false
      this.programList = []
      this.selectedBusinessID = ''
    },
    // viewSingleData: function (item) {
    //   this.viewModel = true
    //   if (typeof item.center === 'object') {
    //     item.center = item.center.join()
    //   }
    //   this.viewModelData = {
    //     'academicYear': item.academicYear,
    //     'zone': item.zone,
    //     'center': item.center,
    //     'program': item.program,
    //     'week': item.week.join()
    //   }
    // },
    saveCMSData: async function () {
      try {
        this.academicYearFlag = false
        this.classSelectedFlag = false
        let payload = {}
        if (this.selectedAcademicId.length <= 0) {
          this.academicYearFlag = true
          this.academicYearErrMsg = 'Please select Academic Year.'
          return
        }
        if (this.selectedClassID.length <= 0) {
          this.classSelectedFlag = true
          this.classErrorMsg = 'Please select Class.'
          return
        }
        if (this.isZoneCurriculum && this.selectedZones.length <= 0) {
          this.zoneSelectedFlag = true
          this.zoneErrorMsg = 'Please select Zones.'
          return
        }
        if (!this.isZoneCurriculum) {
          if (_.isEmpty(this.selectedFranchisees)) {
            this.errMsg('Center Can not be Empty!')
            return
          }
        }
        if (
          this.isZoneCurriculum &&
          this.selectedZones.length === this.zones.length
        ) {
          this.zoneSelectedFlag = true
          this.zoneErrorMsg = 'All access curriculum already exist.'
          return
        }
        payload.academicYear = this.selectedAcademicId
        payload.classID = this.selectedClassID
        payload.franchiseeID = this.selectedFranchisees
        payload.allCenterAccess =
          this.selectedFranchisees.length <= 0 && !this.isZoneCurriculum
        payload.isZoneCurriculum = this.isZoneCurriculum
        payload.zoneID = this.selectedZones
        let res = await http.put(
          `${constants.API_URL}/api/curriculum_cms/update-curriculum/${this.selectedCurriculumCMSId}`,
          payload
        )
        if (res.status === 200) {
          this.getCurriculumList()
          this.closeEditModel()
          this.okMsg('Curriculum CMS is updated Successfully.')
        } else {
          this.errMsg('Curriculum CMS is failed to update.')
        }
      } catch (e) {
        this.errMsg(e.response.data.message)
      }
    },
    modalOpen (type) {
      this.lessonDialog = false
      this.resourceDialog = false
      this.isUploadLesson = false
      this.isUploadResources = false

      if (type === this.lessonType) {
        this.isUploadLesson = true
        this.lessonDialog = true
      } else {
        this.isUploadResources = true
        this.resourceDialog = true
      }
    },
    okMsg (msg) {
      return this.$dialog.message.info(msg, {
        position: 'top-center',
        color: 'success',
        timeout: 4000
      })
    },
    errMsg (msg) {
      return this.$dialog.message.error(msg, {
        position: 'top-center',
        color: 'error',
        timeout: 4000
      })
    }
  }
}
</script>
<style scoped>
.tile.is-child {
  border: 1px solid #ff000059;
}

.fol-name {
  overflow-wrap: break-word;
}

.foldr {
  cursor: pointer;
}

.islink {
  cursor: pointer;
}

.isBlueLink {
  color: #0d6efd;
  text-decoration: underline;
}

.shortFoldername {
  width: 155px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.shortFoldername:hover {
  overflow: visible;
  white-space: normal;
  width: auto;
  position: absolute;
  background-color: #fff;
}

.custom-tab-design {
  background: none !important;
  height: 40px !important;
}

.theme--light.v-tabs>.v-tabs-bar {
  background: none !important;
}
</style>
